import React from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";

function PreorderingForm() {
  return (
    <AuthProvider prefix={"preordering"}>
      <JamezzFormV2
        endPoint={"core/preordering"}
        pageTitle={getTranslation("preordering.form.pageTitel", "Pre ordering")}
        rootRight={"preordering"}
        tabs={[
          {
            right: "algemeen",
            tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"preordering.form.tabs.algemeen"} />,
            tabContent: <Algemeen />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default PreorderingForm;
